const { Component, render, findDOMNode, Fragment, useState, useEffect } = wp.element;
const { __ } = wp.i18n

const {
  MediaUpload
} = wp.editor;

const alias = 'wtop-brands-';

const WTopApp = ({ settings, isBrandLogo }) => {
  
  const [ imageUrl, setImageUrl ] = useState(settings.image_url);
  const [ attachmentId, setAttachmentId ] = useState(settings.attachment_id);
  const [ category, setCategory ] = useState(settings.current_brand_category);
  
  const buildBrandLogo = () => {
    return <Fragment>
      <th scope="row" valign="top">  
      <label for="brand_logo">Brand Logo</label>
      </th>  
      <td>
          <input type="hidden" name="term_meta[brand_logo]" id="term_meta[brand_logo]" value={ attachmentId }></input>
          { imageUrl != null ? <img className={`${alias}image`} src={imageUrl} /> : "" }  
          { imageUrl == null ? <a href="#upload" target="blank" className={`button button-primary kingdom-upload-custom-img ${alias}upload`}
          onClick={(e) => {
            e.preventDefault();

            let frame = wp.media({
              title: __('Select or Upload Brand logo', 'wtopbrands'),
              button: {
                text: __('Use this image', 'wtopbrands')
              },
              multiple: false  // Set to true to allow multiple files to be selected
            });

            frame.on( 'select', function() {

              // Get media attachment details from the frame state
              let attachment = frame.state().get('selection').first().toJSON();
      
              let image_url = attachment.sizes.full.url;
              if( typeof(attachment.sizes.thumbnail) != 'undefined' ){
                image_url = attachment.sizes.thumbnail.url;
              }
              setImageUrl(image_url);
              setAttachmentId(attachment.id);

            });
    
            // Finally, open the modal on click
            frame.open();
          }}
          >Upload Image</a> : "" }

          { imageUrl != null ? <a href="#upload" target="blank" className={`button button-primary ${alias}delete`} onClick={ (e) => {
            e.preventDefault();
            setImageUrl(null);
            setAttachmentId("");
          }}>Delete</a> : "" }  

          <br />  
          <span class="description">{ __( 'Here you can upload a logo for your brand', 'wtopbrands' ) }</span>  
      </td>  
    </Fragment>
  }

  const buildBrandCategory = () => {
    return <Fragment>
      <th scope="row" valign="top">  
        <label for="brand_category">{ __( 'Brand Category', 'wtopbrands' ) }</label>
      </th>
      <td>
      <select name="term_meta[brand_category]" id="term_meta[brand_category]" value={ category } onChange={(e) => {
        setCategory(e.target.value);
      }}>
        <option value="">{ __( 'None', 'wtopbrands' ) }</option>
        { settings.brand_categories.map(( categ, indexCateg ) => {
          return <option value={ categ } >{ categ }</option>
        }) }

      </select>
      <br />  
      <span class="description"> { __( 'Please select a category.', 'wtopbrands' ) } </span>
      { category == "" ? <span style={{ fontWeight: '700' }}>{ __('No category Selected', 'wtopbrands') }</span> : "" }
      </td> 
    </Fragment>
  }

  return <Fragment>
      { isBrandLogo ? buildBrandLogo() : buildBrandCategory() }
    </Fragment>
}

export { WTopApp };

document.addEventListener('DOMContentLoaded', function(event) {
  const searchElement = document.getElementById( `${alias}wrapper` );
  if( searchElement != null ){
    const settings = JSON.parse( searchElement.getAttribute('data-settings') );
    render( <WTopApp settings={ settings } isBrandLogo={ true } />, searchElement );
  }
});


document.addEventListener('DOMContentLoaded', function(event) {
  const searchElement = document.getElementById( `${alias}wrapper2` );
  if( searchElement != null ){
    const settings = JSON.parse( searchElement.getAttribute('data-settings') );
    render( <WTopApp settings={ settings } isBrandLogo={ false } />, searchElement );
  }
});


// WEBPACK FOOTER //
// ./src/app.js